var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../element-factory";
import { SurveyElementBase } from "../reactquestion_element";
var TextAreaComponent = /** @class */ (function (_super) {
    __extends(TextAreaComponent, _super);
    function TextAreaComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.initialValue = _this.viewModel.getTextValue() || "";
        _this.textareaRef = React.createRef();
        return _this;
    }
    Object.defineProperty(TextAreaComponent.prototype, "viewModel", {
        get: function () {
            return this.props.viewModel;
        },
        enumerable: false,
        configurable: true
    });
    TextAreaComponent.prototype.canRender = function () {
        return !!this.viewModel.question;
    };
    TextAreaComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var el = this.textareaRef.current;
        if (!!el) {
            this.viewModel.setElement(el);
        }
    };
    TextAreaComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.viewModel.resetElement();
    };
    TextAreaComponent.prototype.renderElement = function () {
        var _this = this;
        return (React.createElement("textarea", { id: this.viewModel.id, className: this.viewModel.className, ref: this.textareaRef, disabled: this.viewModel.isDisabledAttr, readOnly: this.viewModel.isReadOnlyAttr, rows: this.viewModel.rows, cols: this.viewModel.cols, placeholder: this.viewModel.placeholder, maxLength: this.viewModel.maxLength, defaultValue: this.initialValue, onChange: function (event) { _this.viewModel.onTextAreaInput(event); }, onFocus: function (event) { _this.viewModel.onTextAreaFocus(event); }, onBlur: function (event) { _this.viewModel.onTextAreaBlur(event); }, onKeyDown: function (event) { _this.viewModel.onTextAreaKeyDown(event); }, "aria-required": this.viewModel.ariaRequired, "aria-label": this.viewModel.ariaLabel, "aria-labelledby": this.viewModel.ariaLabelledBy, "aria-describedby": this.viewModel.ariaDescribedBy, "aria-invalid": this.viewModel.ariaInvalid, "aria-errormessage": this.viewModel.ariaErrormessage, style: { resize: this.viewModel.question.resizeStyle } }));
    };
    return TextAreaComponent;
}(SurveyElementBase));
export { TextAreaComponent };
ReactElementFactory.Instance.registerElement("sv-text-area", function (props) {
    return React.createElement(TextAreaComponent, props);
});
